import { render, staticRenderFns } from "./GuardiansEdit.vue?vue&type=template&id=1df69aaa&scoped=true&"
import script from "./GuardiansEdit.vue?vue&type=script&lang=js&"
export * from "./GuardiansEdit.vue?vue&type=script&lang=js&"
import style0 from "./GuardiansEdit.vue?vue&type=style&index=0&id=1df69aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df69aaa",
  null
  
)

export default component.exports